import NiceModal from "@ebay/nice-modal-react";
import { medusaRequester, requester, storeRequester } from "App";
import clsx from "classnames";
import CustomIcon from "components/icons/CustomIcon";
import P from "components/P";
import SkeletonImage from "components/skeleton/SkeletonImage";
import SkeletonText from "components/skeleton/SkeletonText";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { WishReducer } from "shared/redux/reducers/shopping/WishReducer";
import { addCommas } from "shared/utils/Utils";
import style from "./EventProductCard.module.scss";
import { AuthContext } from "providers/AuthProvider";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import EventSticker from "./sticker/EventSticker";
import Sticker from "./sticker/Sticker";
import Dummy from "components/Dummy";
import cartIcon from "resources/img/category/cart.png";

function EventProductCard(props) {
  const { data, type, skeleton } = props;
  const { userName } = useContext(AuthContext);
  const { isMobile } = useContext(BrowserDetectContext);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [wish, setWish] = useState(false);
  const dispatch = useDispatch();
  const { products } = useSelector((state) => ({
    products: state.wish.products,
  }));

  const onProductClick = () => {
    navigate(`/product/detail/${data.id}`);
  };
  const addCartButtonClick = (e) => {
    e.stopPropagation();
    if (isMobile) {
      NiceModal.show("mobileAddCart", { product: data });
    } else {
      NiceModal.show("addCartCount", { product: data });
    }

  };
  const wishButtonClick = async (e) => {
    e.stopPropagation();
    const { customer } = await storeRequester.getCurrentCustomer();
    let interestData = {
      product_id: data.id,
      customer_id: customer.id,
    };
    if (interestData.product_id && interestData.customer_id) {
      medusaRequester
        .addWishProduct(interestData, (result) => {
          toast.success(t("위시리스트 추가 완료"), {
            autoClose: 1000,
            position: toast.POSITION.BOTTOM_CENTER,
          });
        })
        .catch((error) => {

        });
    }
  };

  const GiftSticker = () => {
    return (
      <>
        {data.gift && (
          <div
            style={{
              width: 50,
              height: 50,
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 100,
              backgroundColor: "#0a8fff",
              borderRadius: "100%",
              padding: "5px 10px",
            }}
          >
            <Center>
              <P
                weight={800}
                color={"white"}
              >{`${data.giftStandard} + ${data.gift}`}</P>
            </Center>
          </div>
        )}
      </>
    );
  };

  useEffect(() => {
    if (products && data) {
      let wishYn = false;

      products.map((wish) => {
        if (wish.productId === data.id && wish.userId) {
          wishYn = wish.wishYn;
        }
      });
      setWish(wishYn);
    }
  }, [products]);

  useEffect(() => {
    if (products && data) {
      let wishYn = false;

      products.map((wish) => {
        if (wish.productId === data.id && wish.userId) {
          wishYn = wish.wishYn;
        }
      });
      setWish(wishYn);
    }
  }, [data]);

  return (
    <div className={style.wrap} onClick={data.id && onProductClick} style={{ cursor: data.id && "pointer" }}>
      <VerticalFlex>
        <FlexChild borderBottomRightRadius={"0"}>
          {skeleton ? (
            <div
              className={style.thumbnail}
              style={{ backgroundColor: "#ebebeb" }}
            >
              <SquareWrapper>
                {skeleton ? (
                  <SkeletonImage width={100} />
                ) : (
                  <img className={style.image} src={data.thumbnail} alt={""} />
                )}
              </SquareWrapper>
            </div>
          ) : (
            <div
              className={style.thumbnail}
              style={{ backgroundColor: `${data.bgColor}11` }}
            >

              {/* <SquareWrapper> */}
              {
                data.id &&
                <div>
                  <img
                    src={cartIcon}
                    onClick={skeleton ? null : addCartButtonClick}
                    className={clsx(style.button, style.cartButton, { [style.mobile]: isMobile })}
                  />
                </div>
              }


              <img className={style.image} src={data.thumbnail} alt={""} />
              {isMobile && <Dummy height={"5px"} />}
              {(data && data.event) || data.discount_price ? (
                <Sticker
                  sticker={"promotion"}
                  isEvent={data.event}
                  discount={data.discount_price}
                  price={data.price}
                />
              ) : (
                <P
                  height={"20px"}
                  ellipsis
                  size={12}
                  weight={"900"}
                  color={"red"}
                ></P>
              )}
              {/* </SquareWrapper> */}
            </div>
          )}
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}

export default EventProductCard;
